import { Dialog } from "@headlessui/react";
import { AlertTriangle } from "lucide-react";
import { Modal } from "@unlikelyai-magic/ui/modals";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel = "Leave",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  if (!open) return null;

  return (
    <Dialog open={true} onClose={onCancel}>
      <div className="fixed inset-0 bg-black/30 z-40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <Modal className="w-[400px]">
          <Modal.Content className="p-6">
            <div className="flex flex-col items-center text-center gap-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-red-500">
                <AlertTriangle className="h-6 w-6" />
              </div>
              <div className="flex flex-col gap-1">
                <h3 className="text-base font-semibold text-brand-foreground">
                  {title}
                </h3>
                <p className="text-sm text-brand-muted">{description}</p>
              </div>
              <div className="flex w-full gap-3 pt-2">
                <button
                  type="button"
                  onClick={onCancel}
                  className="flex-1 rounded-lg border border-brand-border px-4 py-2 text-sm font-medium text-brand-foreground hover:bg-brand-primary/5 transition-colors"
                >
                  {cancelLabel}
                </button>
                <button
                  type="button"
                  onClick={onConfirm}
                  className="flex-1 rounded-lg bg-red-500 px-4 py-2 text-sm font-medium text-white hover:bg-red-600 transition-colors"
                >
                  {confirmLabel}
                </button>
              </div>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    </Dialog>
  );
};
